import { useState, useEffect } from 'react';

let cachedPosts = null;

export function usePosts() {
  const [posts, setPosts] = useState(cachedPosts || []);
  const [loading, setLoading] = useState(!cachedPosts);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cachedPosts) {
      setPosts(cachedPosts);
      setLoading(false);
      return;
    }

    const loadPosts = async () => {
      try {
        const response = await fetch('/posts.json');
        if (!response.ok) {
          throw new Error('Failed to load posts');
        }
        const data = await response.json();
        cachedPosts = data;
        setPosts(data);
        setError(null);
      } catch (err) {
        console.error('Error loading posts:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, []);

  return { posts, loading, error };
}

export function usePost(id) {
  const { posts, loading, error } = usePosts();
  const post = posts.find(p => p.id === id || p.slug === id);

  return { post, loading, error, allPosts: posts };
}
